import { getCapitalizedText } from '~utils/string'
import { GroupItem } from './types'

export const getGroupItemDisplayValue = (item: GroupItem) => {
  if (item.label) {
    return getCapitalizedText(item.label)
  }

  if (typeof item.value === 'string') {
    return getCapitalizedText(item.value)
  }

  throw new Error('No group item label or group item value is not string')
}
